import React from 'react';
import { useNavigate } from 'react-router-dom';

const C = {
  pri: '#0a0e27',
  pri2: '#2952CC',
  accent: '#6382eb',
  accent2: '#4f6ef2',
  bg: '#f7f8fc',
  white: '#FFFFFF',
  text: '#444',
  muted: '#666',
  border: '#eef0f5',
  green: '#10b981',
};

const S = {
  wrapper: {
    minHeight: '100vh',
    fontFamily: "'Inter','Segoe UI',system-ui,-apple-system,sans-serif",
    background: C.bg,
  },
  header: {
    background: `linear-gradient(135deg,${C.pri} 0%,#111c4e 50%,#1a2f7a 100%)`,
    padding: '48px 20px 64px',
    textAlign: 'center',
    position: 'relative',
    overflow: 'hidden',
  },
  backBtn: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: '6px',
    color: 'rgba(255,255,255,0.70)',
    textDecoration: 'none',
    fontSize: '14px',
    cursor: 'pointer',
    position: 'relative',
    zIndex: 1,
    marginBottom: '24px',
    background: 'none',
    border: 'none',
    padding: '0',
  },
  h1: {
    fontSize: 'clamp(28px,4vw,44px)',
    fontWeight: 800,
    color: C.white,
    margin: '0 0 12px',
    position: 'relative',
    zIndex: 1,
  },
  sub: {
    fontSize: '16px',
    color: 'rgba(255,255,255,0.55)',
    maxWidth: '600px',
    margin: '0 auto',
    lineHeight: 1.7,
    position: 'relative',
    zIndex: 1,
  },
  body: { maxWidth: '900px', margin: '0 auto', padding: '48px 20px 80px' },
  card: {
    background: C.white,
    borderRadius: '16px',
    padding: '32px',
    border: `1px solid ${C.border}`,
    boxShadow: '0 1px 3px rgba(0,0,0,0.04)',
    marginBottom: '24px',
  },
  h2: { fontSize: '22px', fontWeight: 700, color: C.pri, margin: '0 0 8px' },
  cardText: { fontSize: '15px', color: C.muted, lineHeight: 1.7 },
  grid2: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
    gap: '16px',
    marginTop: '20px',
  },
  miniCard: {
    background: C.bg,
    borderRadius: '12px',
    padding: '20px',
    border: `1px solid ${C.border}`,
  },
  miniH3: { fontSize: '16px', fontWeight: 700, color: C.pri, margin: '0 0 6px' },
  miniP: { fontSize: '14px', color: C.muted, lineHeight: 1.6 },
  pill: (bg, c) => ({
    display: 'inline-block',
    padding: '5px 14px',
    borderRadius: '12px',
    background: bg,
    color: c,
    fontSize: '13px',
    fontWeight: 600,
  }),
  faseRow: { display: 'flex', gap: '16px', alignItems: 'flex-start', marginBottom: '0' },
  num: (a) => ({
    width: '36px',
    height: '36px',
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontWeight: 700,
    fontSize: '15px',
    background: a ? C.accent : '#e5e7eb',
    color: a ? C.white : C.muted,
    flexShrink: 0,
  }),
  cone: (a) => ({
    width: '2px',
    flex: 1,
    background: a ? C.accent : '#e5e7eb',
    margin: '4px 0',
    minHeight: '36px',
  }),
  quote: {
    background: '#eef2ff',
    borderRadius: '12px',
    padding: '20px 24px',
    border: '1px solid #d0d5f0',
    fontSize: '14px',
    color: C.pri2,
    lineHeight: 1.7,
    fontStyle: 'italic',
    marginTop: '20px',
  },
};

const FASES = [
  { n: '01', t: 'BIENVENIDA', d: 'Saludo cálido, construye confianza, menciona ofertas del día.' },
  {
    n: '02',
    t: 'DESCUBRIMIENTO',
    d: 'Muestra categorías, explora necesidades del cliente, sugiere productos complementarios.',
  },
  {
    n: '03',
    t: 'NEGOCIACION',
    d: 'Agrega al carrito, aplica cross-selling y up-selling, maneja objeciones, crea urgencia y escasez.',
  },
  {
    n: '04',
    t: 'CIERRE',
    d: 'Resume el pedido, muestra totales en la moneda del cliente, advierte no pagar hasta verificación del asesor.',
  },
  {
    n: '05',
    t: 'POST-VENTA',
    d: 'Pedido creado. Agradece al cliente, ofrece re-orden, el asesor toma control para verificación de pago y seguimiento.',
  },
];

function BotIADetalle() {
  const nav = useNavigate();
  return (
    <div style={S.wrapper}>
      <style>{'body{overflow:auto!important}'}</style>
      <div style={S.header}>
        <button onClick={() => nav('/#bot')} style={S.backBtn}>
          &#8592; Volver al inicio
        </button>
        <h1 style={S.h1}>Bot Vendedor con Inteligencia Artificial</h1>
        <p style={S.sub}>
          El bot no solo responde preguntas. VENDE. Conoce el inventario real, sugiere productos,
          maneja objeciones y cierra pedidos.
        </p>
      </div>
      <div style={S.body}>
        <div style={S.card}>
          <h2 style={S.h2}>Funnel de Ventas de 5 Fases</h2>
          <p style={S.cardText}>
            Cada conversación sigue una máquina de estados diseñada para maximizar la conversión:
          </p>
          <div style={{ marginTop: '24px' }}>
            {FASES.map((f, i) => (
              <div key={i} style={S.faseRow}>
                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    width: '48px',
                    flexShrink: 0,
                  }}
                >
                  <div style={S.num(true)}>{f.n}</div>
                  {i < FASES.length - 1 && <div style={S.cone(true)} />}
                </div>
                <div style={{ paddingBottom: i < FASES.length - 1 ? '28px' : '0' }}>
                  <h4
                    style={{ fontSize: '16px', fontWeight: 700, color: C.pri, margin: '0 0 4px' }}
                  >
                    {f.t}
                  </h4>
                  <p style={{ fontSize: '14px', color: C.muted, margin: 0, lineHeight: 1.5 }}>
                    {f.d}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div style={S.card}>
          <h2 style={S.h2}>Skills Configurables</h2>
          <p style={S.cardText}>
            Desde el panel de administración se ajusta el comportamiento del bot sin tocar código.
            Cada empresa afina sus <strong>skills</strong> de forma sencilla:
          </p>
          <div style={S.grid2}>
            {[
              {
                t: 'Temperatura de IA',
                d: 'Que tan creativo o preciso es el bot. Valor recomendado: 0.4. Ajustable entre 0 (exacto) y 1 (creativo).',
              },
              {
                t: 'Máximo de tokens',
                d: 'Longitud máxima de respuesta. Default 2000 tokens. Para respuestas más breves o más extensas según necesidad.',
              },
              {
                t: 'Nombre del bot',
                d: 'Cada empresa le pone nombre a su bot. Ej: "Ana", "Carlos Toko", "Asistente Girasol". El bot se presenta con ese nombre.',
              },
              {
                t: 'Mensaje de no entendido',
                d: 'Qué dice cuando no comprende. Ej: "Disculpa, no entendí. ¿Puedes ser más específico con lo que buscas?"',
              },
              {
                t: 'Prompt personalizado',
                d: 'El texto base que define el tono, estilo y personalidad del bot. Puede ser formal, casual, tecnico, carinoso, etc.',
              },
              {
                t: 'Sistema de aprendizaje',
                d: 'El bot registra ejemplos positivos y negativos de interacciones. Estos se usan para refinar el prompt y mejorar respuestas futuras.',
              },
            ].map((x, i) => (
              <div key={i} style={S.miniCard}>
                <h3 style={S.miniH3}>{x.t}</h3>
                <p style={S.miniP}>{x.d}</p>
              </div>
            ))}
          </div>
        </div>

        <div style={S.card}>
          <h2 style={S.h2}>Como Funciona el Cache Inteligente</h2>
          <p style={S.cardText}>
            El sistema identifica preguntas repetitivas como "¿cuánto cuesta?", "gracias", "¿qué
            horario tienen?", "confirmar pedido" y las guarda en memoria (cache TTL de 300 segundos,
            máximo 200 entradas).
          </p>
          <p style={S.cardText}>
            Cuando otro cliente hace la misma pregunta, el bot responde instantaneamente desde el
            cache sin llamar a la API de IA, lo que reduce drasticamente el costo operativo.
          </p>
          <div style={S.quote}>
            <strong>Ejemplo real: </strong>
            Un cliente escribe "A que hora cierran?" → Ya esta en cache → $0 de costo.
            <br />
            Luego escribe "Quiero saber si tienen pepperoni" → Pregunta nueva → Genera consumo en la
            API.
            <br />
            <br />
            En una conversación típica de 7 mensajes, aproximadamente 2-3 ya están en cache. Por eso
            el gasto real es mucho menor de lo que parece.
          </div>
        </div>

        <div style={S.card}>
          <h2 style={S.h2}>Busqueda Inteligente de Productos</h2>
          <div style={S.grid2}>
            {[
              {
                t: 'Busqueda exacta',
                d: 'Encuentra productos por codigo o nombre exacto en el inventario de la sede del cliente.',
              },
              {
                t: 'Busqueda difusa (fuzzy)',
                d: 'Tolera errores tipograficos: "arina pan" encuentra "harina pan". Usa algoritmo de similitud.',
              },
              {
                t: 'Fallback a sede principal',
                d: 'Si no encuentra en la sede del cliente, busca en la sede matriz (0101) antes de decir "no disponible".',
              },
              {
                t: 'Productos pesables',
                d: 'Entiende medidas: kg, g, lb, unidades. Convierte automaticamente. "2 kilos de queso" → 2000g.',
              },
              {
                t: 'Multi-producto',
                d: 'Procesa listas: "2 harinas, 1 arroz y 3 caraotas". Separa por comas, "y", "e". Asigna cantidades correctas.',
              },
              {
                t: 'Cross-selling',
                d: 'Mapa de productos complementarios: harina→queso, arroz→caraotas, pan→jamon. Sugiere automaticamente.',
              },
            ].map((x, i) => (
              <div key={i} style={S.miniCard}>
                <h3 style={S.miniH3}>{x.t}</h3>
                <p style={S.miniP}>{x.d}</p>
              </div>
            ))}
          </div>
        </div>

        <div style={S.card}>
          <h2 style={S.h2}>Transicion Bot ↔ Asesor Humano</h2>
          <p style={S.cardText}>
            El sistema detecta automáticamente cuando un cliente necesita atención humana y
            transfiere el chat al asesor. El bot se retira y deja de responder. Cuando el asesor
            termina la atención, libera el chat y el bot retoma si es necesario.
          </p>
          <p style={S.cardText}>
            Si el pedido entra en fase de gestión (en revisión, aprobado, esperando pago), el bot
            deja de intervenir automáticamente para evitar confusiones. Solo el asesor humano maneja
            el pedido en esas etapas.
          </p>
        </div>
        <button
          onClick={() => nav('/#bot')}
          style={{
            ...S.backBtn,
            color: C.pri2,
            display: 'block',
            margin: '0 auto',
            fontSize: '16px',
            fontWeight: 600,
          }}
        >
          &#8592; Volver al inicio
        </button>
      </div>
    </div>
  );
}

export default BotIADetalle;
